import React from "react";
import { Link } from "react-router-dom";
import { SortableElement, SortableHandle } from "react-sortable-hoc";
import isEmpty from "lodash/isEmpty";

import { REACT_APP_RESOURCE_URL } from "../../../shared/vars";

const DragHandle = SortableHandle(() => <div className="icon icon-sort" />); // This can be any component you want

export default SortableElement(({ value, updateLoading }) => {
	return (
		<li className={"sortable-category flex-sort-item" + (updateLoading ? " disabled" : "")}>
			<DragHandle />
			<img src={REACT_APP_RESOURCE_URL + value.sizes.full.src} alt={value.alt} />
			<div className="title">{value.alt}</div>
			{!isEmpty(value.banners) && (
				<Link className="sub-sort-Link" to={"/admin/banners/sort/"}>
					Edit
				</Link>
			)}
		</li>
	);
});



// WEBPACK FOOTER //
// ./src/components/admin/banners-sort/SortableElement.js